import request from '@/utils/request'


// 海报页列表
export async function api_postPostersList(data) {
  return request({
    url: '/rest/poster/activity/page',
    method: 'post',
    data,
  })
}

// 创建海报页
export async function api_postCreatedPosters(data) {
  return request({
    url: '/rest/poster/activity',
    method: 'post',
    data,
  })
}

// 修改海报页
export async function api_putUpdatePosters(data) {
  return request({
    url: '/rest/poster/activity',
    method: 'put',
    data,
  })
}

// 海报页详情
export async function api_getPostersDetail(params) {
  return request({
    url: '/rest/poster/activity',
    method: 'get',
    params,
  })
}

// 修改海报页状态
export async function api_putSwitchPosters(params) {
  return request({
    url: '/rest/poster/activity/switch',
    method: 'put',
    params,
  })
}

// 删除海报页
export async function api_deletePosters(params) {
  return request({
    url: '/rest/poster/activity',
    method: 'delete',
    params,
  })
}
